import axios from 'axios';
import {configs} from "../config/config";
import storage from '../utils/storage';
import { message } from 'antd';

const  service = axios.create({
    baseURL: configs.service.baseUrl,
    withCredentials: true,
    timeout: configs.service.timeout
});


/**
 *  request interceptors
 */

service.interceptors.request.use(config => {
    let _url = config.url
    if (_url.indexOf("login") === -1){
        // not login page 
        if (storage.check(configs.cache.tokenKey)) {
            let bearerToken = storage.get(configs.cache.tokenKey);
            config.headers['content-type'] = "application/json";
            config.headers["token"] = bearerToken.token;
        }else{
            message.error("token expired")
            storage.clear();
            window.location.href = configs.default.route;
        }
    }else{
        config.headers['content-type'] = "application/json";
    }
    return config;
}, error => {
        return Promise.reject(error)
    }
);


service.interceptors.response.use(
    response=>{
        const res = response
        if(res.data.code === 200001 || res.data.code ===200002){
            storage.clear()
            window.location.href = configs.default.route;
        }else{

            return res;
        }
    },error=>{
        const errRes = error.response
        return Promise.reject(errRes)
    }
)


export default service;